import { createContext } from 'react';

const ConfigPrioritizationContext = createContext({
    APIEndpoints: '',
    action: ''
});

export default ConfigPrioritizationContext;